import config from "@/config";
import cookies from "@/util/cookies";
import http from "@/plugins/axios_plugin";

class Services {
  // Config Axios

  configAxios(defaults) {
    defaults.baseURL = config.apiUrl;
    defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    defaults.headers.common["Authorization"] =
      "Bearer " + cookies.get("api_token");
  }

  // Estados

  estados() {
    return [
      { value: 12, text: "Acre" },
      { value: 27, text: "Alagoas" },
      { value: 16, text: "Amapá" },
      { value: 13, text: "Amazônia" },
      { value: 29, text: "Bahia" },
      { value: 23, text: "Ceará" },
      { value: 53, text: "Distrito Federal" },
      { value: 32, text: "Espírito Santo" },
      { value: 52, text: "Goiás" },
      { value: 21, text: "Maranhão" },
      { value: 51, text: "Mato Grosso" },
      { value: 50, text: "Mato Grosso do Sul" },
      { value: 31, text: "Minas Gerais" },
      { value: 15, text: "Pará" },
      { value: 25, text: "Paraíba" },
      { value: 41, text: "Paraná" },
      { value: 26, text: "Pernambuco" },
      { value: 22, text: "Piauí" },
      { value: 33, text: "Rio de Janeiro" },
      { value: 24, text: "Rio Grande do Norte" },
      { value: 43, text: "Rio Grande do Sul" },
      { value: 11, text: "Rondônia" },
      { value: 14, text: "Roraima" },
      { value: 42, text: "Santa Catarina" },
      { value: 35, text: "São Paulo" },
      { value: 28, text: "Sergipe" },
      { value: 17, text: "Tocantins" },
    ];
  }

  // Procura o índice em um Dataset

  getIndexDataset(dataset, value, key) {
    return dataset.find((item) => {
      return item[key] == value;
    });
  }

  cidades(estado) {
    return http.get("/api/cidades?estado=" + estado);
  }

  categorias() {
    return http.get("/api/categorias");
  }

  // Regimes Tributários

  regimesTributariosIndex() {
    return [
      { value: 1, text: "Simples Nacional" },
      { value: 2, text: "Lucro Presumido" },
      { value: 3, text: "Normal" },
    ];
  }
}

export default new Services();
